import React, { useContext, useEffect, useState } from 'react';
import { uploadFile } from "../services/utilService";
import { saveMeta } from "../services/metaService";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import UserContext from "../contexts/UserContext";
import { Spinner } from 'reactstrap';
import { mintNFT, getMintFees } from "../utils/marketPlaceInteractor";
import { getTokenIdFromTxn, marketplaceContractAddress, web3 } from "../utils/blockchainInteractor";
import useLoader from "../hooks/useLoader";
import * as Yup from 'yup';
import { approveSpenderERC20, getSymbolERC20 } from '../utils/erc20Interactor';
const re = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
const NFT_VALIDATION_SCHEMA = Yup.object().shape({
    name: Yup.string()
        .max(120, 'Too Long!')
        .required('Title is Required'),
    description: Yup.string()
        .required('Description is Required'),
    category: Yup.string()
        .required('Category is Required'),
    image: Yup.string()
        .required('Image is  Required')
});
function MintPage(props) {
    const history = useHistory();
    const userContext = useContext(UserContext);
    const { handleStart, state } = userContext;
    const { user } = state;
    const [loader, showLoader, hideLoader] = useLoader();
    const [isLoading, setIsLoading] = useState(false);
    const [mintFees, setMintFees] = useState('0');
    const [ERCSYMBOL, setERCSYMBOL] = useState('');

    const init = async () => {
        if (!user) await handleStart();
        setMintFees(await getMintFees());
        setERCSYMBOL((await getSymbolERC20()));
    }

    useEffect(() => {
        init()
    }, [user])

    let newNFT = {
        name: '',
        description: '',
        category: '',
        image: '',
    };
    const onSubmit = async (values, { resetForm, setSubmitting }) => {
        await submit(values);
        setSubmitting(false)
        resetForm()
    };

    const setFileChange = async (files, setFieldValue) => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', files[0]);
            const { data } = await uploadFile(formData);
            const url = data.Location;
            if (url) {
                setFieldValue('image', url);
            }
        } catch (e) {
            toast.error('Something went wrong!')
        } finally {
            setIsLoading(false);
        }
    };

    const submit = async (values) => {
        showLoader('Minting....')
        try {
           const approved = await approveSpenderERC20(marketplaceContractAddress,mintFees);
           const tx = await mintNFT();
            const tokenID = getTokenIdFromTxn(tx);
            await saveMeta({ ...values, tokenID });
            history.push(`/nft/${tokenID}`)
            toast.success(`NFT minted with ${tokenID}`);
        } catch (err) {
            console.log(err);
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
        }
    };

    return (
        <>
            {
                loader
            }
            <div className="minting-wrap">
                <div className="container">
                    <div className="fox-heading create-item-heading text-center">
                        <h4>Create Item</h4>
                    </div>
                    <Formik initialValues={newNFT} validationSchema={NFT_VALIDATION_SCHEMA} onSubmit={onSubmit}>
                        {({ isSubmitting, values, setFieldValue, errors, touched, handleChange }) => (
                            <Form autoComplete="random_string">
                                <div className="minting-row">
                                    <div className="prev-item-wrp">
                                        <div className="item-heading">
                                            <h5>Preview Item</h5>
                                        </div>
                                        <div className="nft-prev">
                                            <div className="nft-card nft-prev-card">
                                                <div className="nft-card-image d-flex align-items-center justify-content-center">
                                                    {isLoading ? <div className="text-center">
                                                        <Spinner style={{ width: '6rem', height: '6rem' }}
                                                            size="lg" color="primary" />
                                                    </div> : <img src={values?.image || "assets/img/nft-top-image.png"} alt="" className="img-fluid" />
                                                    } </div>
                                                <div className="nft-card-content">
                                                    <div className="nft-txt-heading">
                                                        <h6>{values?.name || '<Title>'}</h6>
                                                    </div>
                                                    <p>{values?.category || '<Category>'}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <p className='mt-4'>Mint Fee of { web3.utils.fromWei(mintFees || '0') } {ERCSYMBOL} will be charged.</p>
                                    </div>
                                    <div className="item-info-wrp" style={{ 'width': '100%' }}>
                                        <div className="item-heading">
                                            <h5>Item Information</h5>
                                        </div>
                                        <div className="itm-info-form">

                                            {!values.image ?
                                                <div className="form-group itm-frm-grp">
                                                    <label>Upload file</label>
                                                    <div className="file-upload-wrapper">
                                                        <input className="upload-path" placeholder="PNG, JPG, JPEG, GIF, WEBP or MP4  |  max 32Mb" disabled />
                                                        <label htmlFor="file-upload" className="upload">
                                                            <input id="file-upload"
                                                                type="file"
                                                                className="d-none"
                                                                name="nftImage"
                                                                onChange={({ currentTarget }) => {
                                                                    setFileChange(currentTarget.files, setFieldValue)
                                                                    currentTarget.value = null;
                                                                }}
                                                                accept="image/*" />
                                                            <span>Upload File</span>
                                                        </label>
                                                    </div>
                                                    {errors.image && touched.image ? (
                                                        <div className="text-danger mt-2">{errors.image}</div>
                                                    ) : null}
                                                </div> : null}
                                            <hr />
                                            <div className="form-group itm-frm-grp">
                                                <label>Title</label>
                                                <input type="text" className="form-control" placeholder="Item Name" value={values.name}
                                                    onChange={handleChange} type="text" name="name" autoComplete="off" />
                                                {errors.name && touched.name ? (
                                                    <div className="text-danger mt-2">{errors.name}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group itm-frm-grp">
                                                <label>Category</label>
                                                <select className="form-control" value={values.category}
                                                    onChange={handleChange} name="category">
                                                    <option disabled value="">Select Category</option>
                                                    <option value="ART">Art</option>
                                                    <option value="PHOTO">Photo</option>
                                                    <option value="GIF">Gif</option>
                                                </select>
                                                {errors.category && touched.category ? (
                                                    <div className="text-danger mt-2">{errors.category}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group itm-frm-grp itm-frm-des">
                                                <label>Description</label>
                                                <textarea value={values.description} style={{ resize: 'none' }} onChange={handleChange}
                                                    name="description" id="editor"
                                                    rows="6" placeholder="Enter Description..." className="form-control" />
                                                {errors.description && touched.description ? (
                                                    <div className="text-danger mt-2">{errors.description}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group item-btn-wrp">
                                                <button disabled={isSubmitting} type="submit" className="btns info-btn">Mint Item</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>

        </>
    );
}

export default MintPage;
